// extracted by mini-css-extract-plugin
module.exports = {"text":"BranchLocalizationItem_text__j30kV"};